import { ArrowRight, CheckCircle2, Plug, RefreshCw, TriangleAlert } from 'lucide-react';

import { useMutation, useQuery } from '@tanstack/react-query';

import { useNavigate } from 'react-router-dom';

import { connectBlume, getBlumeOverview } from '../../features/integrations/blume/api';

import './IntegrationsPage.scss';

import { AppSidebar } from '../../components/AppSidebar/AppSidebar';

export function IntegrationsPage() {
  const navigate = useNavigate();

  const { data, isLoading, error } = useQuery({
    queryKey: ['blume-overview'],

    queryFn: getBlumeOverview,
  });

  const connectMutation = useMutation({
    mutationFn: connectBlume,

    onSuccess: ({ authorizeUrl }) => {
      window.location.assign(authorizeUrl);
    },
  });

  const connected = !!data?.connected;

  return (
    <div className="layout">
      <AppSidebar />

      <div className="integrations-page">
        <header className="integrations-page__header">
          <div>
            <p className="integrations-page__eyebrow">System configuration</p>

            <h1>Integrations</h1>

            <p>Connect external systems to Bulk Material Pro.</p>
          </div>
        </header>

        <div className="integration-grid">
          <section className="integration-card">
            <div className="integration-card__top">
              <div className="integration-card__icon">
                <Plug size={24} />
              </div>

              <div className="integration-card__identity">
                <div className="integration-card__title-row">
                  <h2>Blume</h2>

                  {connected && (
                    <span className="integration-status integration-status--active">
                      <CheckCircle2 size={14} />
                      Connected
                    </span>
                  )}

                  {!connected && data && data.status && (
                    <span className="integration-status integration-status--warning">
                      <TriangleAlert size={14} />

                      {data.status}
                    </span>
                  )}
                </div>

                <p>
                  Sync customer credit from Blume and manage QuickBooks product and service mappings
                  for Bulk Material Pro.
                </p>
              </div>
            </div>

            {isLoading && (
              <div className="integration-card__loading">
                <RefreshCw size={18} className="spin" />
                Loading integration…
              </div>
            )}

            {error && (
              <div className="integration-card__error">
                Unable to load Blume integration status.
              </div>
            )}

            {!isLoading && data && connected && (
              <>
                <div className="integration-card__capabilities">
                  <span>Customer credit sync</span>

                  <span>Customer mappings</span>

                  <span>QuickBooks product mappings</span>
                </div>

                <div className="integration-card__meta">
                  {data.lastSyncAt ? (
                    <>Last customer sync {new Date(data.lastSyncAt).toLocaleString()}</>
                  ) : (
                    'Customers have not been synced yet'
                  )}
                </div>
              </>
            )}

            <div className="integration-card__actions">
              {connected ? (
                <button
                  type="button"
                  className="integration-btn integration-btn--primary"
                  onClick={() => navigate('/integrations/blume')}
                >
                  Manage Blume
                  <ArrowRight size={16} />
                </button>
              ) : (
                <button
                  type="button"
                  className="integration-btn integration-btn--primary"
                  disabled={connectMutation.isPending}
                  onClick={() => connectMutation.mutate()}
                >
                  {connectMutation.isPending ? 'Connecting…' : 'Connect Blume'}
                </button>
              )}
            </div>

            {connectMutation.error && (
              <p className="integration-card__error">{(connectMutation.error as Error).message}</p>
            )}
          </section>
        </div>
      </div>
    </div>
  );
}
